/**
 * Every real object under `owner`, depth-first in document order, descending through Sets.
 *
 * Yields objects ONLY — a Set is a container, not a thing on stage, and no caller of this wants to
 * type-test for one. Callers that need the groups themselves use `eachSet`.
 */
export function* eachObjectNode(owner) {
    for (const child of owner.children) {
        yield child;
        yield* eachObjectNode(child);
    }
    if ("sets" in owner && owner.sets) {
        for (const set of owner.sets)
            yield* eachObjectNode(set);
    }
}
/** The rider root and every real object in it — the owners of audio/gear lines. A Set owns none
 *  (lines belong to real equipment, `docs/BUG_AUDIO_LISTS.md`), which is why it is absent here. */
export function* eachLineOwner(rider) {
    yield rider;
    yield* eachObjectNode(rider);
}
// Both of these walk with `eachLineOwner`, which reaches into containers, rather than recursing
// through `children` by hand. The hand-rolled walk missed every object inside a Set, so deleting a
// line off a grouped object found nothing and silently did nothing — and since the Set every
// dropped preset IS grouped, that was the ordinary case rather than an edge one.
export function findInputItemByChannel(rider, channel) {
    for (const owner of eachLineOwner(rider)) {
        const index = owner.input_list.findIndex((item) => item.Channel === channel);
        if (index !== -1)
            return { owner, index };
    }
    return undefined;
}
export function findOutputItemByChannel(rider, channel) {
    for (const owner of eachLineOwner(rider)) {
        const index = owner.output_list.findIndex((item) => item.Channel === channel);
        if (index !== -1)
            return { owner, index };
    }
    return undefined;
}
//# sourceMappingURL=rider-walk.js.map